<template>
  <div class="form-card">
    <receipt-add-product v-if="showModal" v-on:sendProduct='sendProduct' v-on:close="showModal=false"/>
    <div class="form-card__header">
      <h2 class="form-card__title">
        <i class="bi bi-box-seam"></i>
        Productos de la compra
      </h2>
    </div>
    <div class="form-card__body">
      <div class="products-panel compra-products">
        <div class="card products-card mb-1">
          <div class="products-card__header">
            <div class="products-card__search">
              <receipt-products-search separator="*"
                :product_default="product_default" :show-barcodes="showBarcodes" :price-list="0" v-on:productadded="getProduct"/>
            </div>
            <button v-if="config.customlabel!='false'" type="button" class="btn btn-outline-primary products-card__add" @click="showModal = true">
              Agregar producto <i class="bi bi-plus-lg"></i>
            </button>
          </div>

          <div class="products-card__body">
            <table v-if="products.length > 0" class="table products-table table-striped">
              <thead>
                <tr>
                  <th class="products-table__num">#</th>
                  <th v-if="showBarcodes">Código</th>
                  <th>Producto</th>
                  <th class="text-center products-table__qty-col">Cantidad</th>
                  <th v-if="showPrices" class="text-right products-table__price-col">Precio unitario</th>
                  <th v-if="showTaxes && disciva" class="text-center products-table__iva-col">% IVA</th>
                  <th v-if="showPrices" class="text-right">Total</th>
                  <th class="text-center products-table__actions">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(prod, index) in products.slice().reverse()" :key="prod.id + '-' + index">
                  <td class="products-table__num">{{ products.length - index }}</td>
                  <td v-if="showBarcodes">
                    <div class="d-flex flex-column products-table__codes text-left">
                      <small v-if="prod.code" class="text-muted" title="Código interno">
                        <i class="bi bi-hash mr-1"></i>{{ prod.code }}
                      </small>
                    </div>
                  </td>
                  <td>{{prod.name}}</td>

                  <!-- CANTIDAD -->
                  <td class="text-center">
                    <div class="qty-stepper">
                      <button type="button" class="qty-stepper__btn" :disabled="prod.quantity <= 0.0001" @click="decrementQty(prod)">−</button>
                      <input v-model.number="prod.quantity" min="0" step="0.0001" type="number" class="qty-stepper__input">
                      <button type="button" class="qty-stepper__btn" @click="incrementQty(prod)">+</button>
                    </div>
                  </td>

                  <!-- PRECIO UNITARIO -->
                  <td v-if="showPrices && disciva" class="text-right">
                    <div class="input-group input-group-sm products-table__price-edit">
                      <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                      <input v-model.number="prod.gross" min="0" step="0.0001" type="number" class="form-control text-right">
                    </div>
                  </td>
                  <td v-if="showPrices && !disciva" class="text-right">
                    <div class="input-group input-group-sm products-table__price-edit">
                      <div class="input-group-prepend"><span class="input-group-text">$</span></div>
                      <input v-model.number="prod.price" min="0" step="0.0001" type="number" class="form-control text-right">
                    </div>
                  </td>

                  <!-- IVA -->
                  <td v-if="showTaxes && disciva" class="text-center">{{prod.ivatype}}%</td>

                  <!-- TOTAL -->
                  <td v-if="showPrices && disciva" class="text-right products-table__total">{{ formatoDinamicoMoneda(round(prod.quantity * prod.gross,2)) }}</td>
                  <td v-if="showPrices && !disciva" class="text-right products-table__total">{{ formatoDinamicoMoneda(round(prod.quantity * prod.price,2)) }}</td>

                  <!-- BTN BORRAR -->
                  <td class="text-center">
                    <button type="button" class="btn btn-outline-danger btn-sm products-table__delete" title="Borrar producto" @click="deleteproduct(prod.id)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div v-else class="products-card__empty">
              <i class="bi bi-box-seam"></i>
              <h5>Todavía no hay productos</h5>
              <p class="text-muted small mb-0">Buscá un producto por su nombre, código o descripción arriba.</p>
            </div>
          </div>
        </div>

        <div v-if="products.length > 0" class="products-summary">
          <span class="products-summary__count">
            {{ products.length }} {{ products.length === 1 ? 'producto' : 'productos' }} <i class="bi bi-cart"></i>
          </span>
          <span class="products-summary__items">
            Items: <strong>{{ itemsCount }}</strong> <i class="bi bi-box"></i>
          </span>
          <div class="products-summary__right">
            <button type="button" class="btn btn-outline-danger btn-sm" @click="cleanAll()">
              <i class="bi bi-trash"></i> Vaciar todo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import receiptProductsSearch from '../../../ventas/pos-document/receipt/Receipt-products-search.vue';
import receiptAddProduct from './Receipt-addProduct.vue';
import roundMixin from "../../../../mixins/roundMixin.js";
import formatMoneyMixin from "../../../../mixins/formatMoneyMixin.js";

export default {
  components:{
    receiptProductsSearch,
    receiptAddProduct,

  },
  mixins: [roundMixin, formatMoneyMixin ],

  props: ['showPrices', 'config', 'prexistprd', 'showBarcodes', 'showTaxes', 'product_default', 'disciva'],
  data: function() {
    return {
      prex: this.prexistprd,
      products: [],
      showModal: false
    };
  },
  computed: {
    itemsCount() {
      return this.products.reduce((sum, p) => sum + (parseFloat(p.quantity) || 0), 0);
    }
  },
  watch: {
    products: {
      handler: function() {
        for (var i = 0; i < this.products.length; i++) {
          if (this.products[i].quantity<0) this.products[i].quantity=0;
        }
        this.$emit('productschanged', this.products);
      }, deep: true,
    },
  },
  mounted: function () {
    if (this.prex) {
      for (var i = 0; i < this.prexistprd.length; i++) {
        this.products.push(this.prex[i]);
      }
      this.prex=null;
      this.$emit('productschanged', this.products);
    }
  },
  methods: {
    deleteproduct: function(id) {
        for (var i = 0; i < this.products.length; i++) {
          if (this.products[i].id === id) {
            this.products.splice(i,1);
          }
        }
    },
    sendProduct (product) {
      this.$emit('sendProduct', product);
      this.products.push(product);
      this.showModal = false;
    },
    getProduct: function(item) {
      item.price = parseFloat(item.price);

      for (var i = 0; i < this.products.length; i++) {
        if (this.products[i].id === item.id) {
          this.products[i].quantity = this.products[i].quantity + item.quantity;
          this.products[i].total = this.products[i].quantity * this.products[i].price;
          return;
        }
      }

      this.products.push(item);
    },
    incrementQty(prod) {
      prod.quantity = (parseFloat(prod.quantity) || 0) + 1;
    },
    decrementQty(prod) {
      prod.quantity = Math.max(0, (parseFloat(prod.quantity) || 0) - 1);
    },
    cleanAll() {
      if (confirm('¿Está seguro que desea borrar todos los productos?')) {
        this.products = [];
      }
    }
  },

  
 

}

</script>

<style lang="scss">
.delete-product {
   font-size:22px;
   color:#b3b2b2;
   cursor:pointer;
   &:hover {
     color: #BE3631;
   }
}

.ok-payment-method {
   font-size:22px;
   color:#b3b2b2;
   cursor:pointer;
   &:hover {
     color: #3a9a09;
   }
}

// Las clases .products-card / .products-table / .qty-stepper / .products-summary
// viven en sale-detail.scss SCOPEADAS bajo ".sale-detail" (ese layout fuerza
// flex a pantalla completa, pensado para POS/Combos). Esta pagina es un form
// clasico, no full-height, asi que en vez de agregar ".sale-detail" como
// ancestro (rompe el alto de toda la pagina) se copian aca las reglas que
// hacen falta, scopeadas a ".compra-products" y con un alto fijo en vez de
// flex-grow para el body de la tabla.
.compra-products {
  .products-card {
    border: 1px solid var(--border-soft);
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    background: var(--surface);
    overflow: visible;
    display: flex;
    flex-direction: column;

    &__header {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 14px;
      background: var(--surface);
      border-bottom: 1px solid var(--border-soft);
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }

    &__search {
      flex: 1 1 auto;
      min-width: 0;
    }

    &__add {
      flex-shrink: 0;
      height: 38px;
      white-space: nowrap;
      font-size: 0.85rem;
      padding: 0 14px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }

    &__body {
      height: 380px;
      overflow-y: auto;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }

    &__empty {
      padding: 80px 24px;
      text-align: center;
      color: var(--text-muted);

      i {
        font-size: 36px;
        color: var(--border-strong);
        margin-bottom: 12px;
        display: block;
      }

      h5 {
        color: var(--text-soft);
        margin-bottom: 4px;
        font-weight: 600;
      }
    }

    @media (max-width: 767px) {
      &__header {
        flex-direction: column;
        align-items: stretch;
      }

      &__add {
        width: 100%;
        justify-content: center;
      }
    }
  }

  .products-table {
    margin-bottom: 0;
    border: 0;
    width: 100%;

    th {
      background: var(--surface-subtle);
      font-size: 11px;
      text-transform: none;
      letter-spacing: 0;
      color: var(--text-muted);
      font-weight: 500;
      border-top: 0;
      padding: 8px 12px;
      white-space: nowrap;
      position: sticky;
      top: 0;
      z-index: 2;
      border-bottom: 0;
      box-shadow: inset 0 -1px 0 var(--border-soft);
    }

    td {
      vertical-align: middle;
      padding: 6px 12px;
      font-size: 13px;
      color: var(--text);
      border-top: 1px solid var(--border-soft);
      border-bottom: 0;
      line-height: 1.3;
    }

    tbody tr:first-child td {
      border-top: 0;
    }

    &__num {
      width: 36px;
      color: var(--text-muted);
      font-size: 12px;
      text-align: center;
    }

    &__actions {
      width: 80px;
    }

    &__total {
      font-weight: 600;
      white-space: nowrap;
    }

    &__price-edit {
      max-width: 190px;
      margin: 0 auto;

      .input-group-text {
        border: 1px solid var(--border);
        background-color: var(--surface-muted);
        color: var(--text-soft);
      }
    }

    &__iva-col {
      width: 60px;
    }

    &__qty-col {
      width: 24ch;
    }

    &__price-col {
      width: 24ch;
    }

    &__delete {
      width: 30px;
      height: 30px;
      padding: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  .qty-stepper {
    display: inline-flex;
    align-items: center;
    gap: 4px;

    &__btn {
      width: 26px;
      height: 28px;
      padding: 0;
      line-height: 1;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--border);
      background: var(--surface);
      color: var(--text);
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;

      &:hover:not(:disabled) {
        background: var(--surface-hover);
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }

    &__input {
      width: 44px;
      height: 28px;
      padding: 0 4px;
      text-align: center;
      border: 1px solid var(--border);
      border-radius: 4px;
      font-size: 13px;
      color: var(--text);
      background: var(--surface);
      -moz-appearance: textfield;
      appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
      }
    }
  }

  .products-summary {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 8px 16px;
    background: var(--surface-subtle);
    border: 1px solid var(--border-soft);
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
    font-size: 13px;
    color: var(--text-soft);
    flex-shrink: 0;
    margin-top: 8px;

    &__count {
      font-weight: 600;
      color: var(--text);
    }

    &__items {
      color: var(--text-muted);

      strong {
        color: var(--text);
        font-weight: 600;
      }
    }

    &__right {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 16px;
    }
  }
}
</style>
